module.exports = __webpack_public_path__ + "img/android.ade13246.svg";